export const PROJECTS = '/projects';
export const OVERVIEW = '/overview';
export const SUMMARY = '/summary';
export const PROTOCOL = '/protocol';
export const SCREENING = '/screening';
export const FAILED_IMPORTS = '/failed-imports';
export const TOTAL_RECORDS_IMPORTED = '/total-records-imported';
export const REMOVED_DUPLICATE_PAGE = '/removed-duplicate-page';
export const POSSIBLE_DUPLICATE_RECORDS = '/possible-duplicate-records';
export const TITLE_AND_ABSTRACT_SCREENING = '/title-and-abstract-screening';
export const FULL_TEXT_SCREENING = '/full-text-screening';
export const AWAITING_SCREENING = '/awaiting-screening';
export const INCLUDED = '/included';
export const EXCLUDED = '/excluded';
export const RESOLVED = '/resolved';
export const CONFLICTED = '/conflicted';
export const MY_DECISIONS = '/my-decisions';
export const APPRAISALS = '/appraisals';
export const EXTRACTIONS = '/extractions';
export const SYNTHESIS = '/synthesis';
export const QUALITATIVE = '/qualitative';
export const META_ANALYSIS = '/meta-analysis';
export const SINGULAR = '/singular';
export const STUDIES = '/studies';
export const REVIEW = '/review';

